import React from 'react';
import CognitoUserManagement from './CognitoUserManagement';

interface UserManagementProps {
  user: any;
  session?: any;
}

const UserManagement: React.FC<UserManagementProps> = ({ user, session }) => {
  return (
    <div>
      <div className="dashboard-card" style={{ marginBottom: '32px', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7' }}>
        <h3 style={{ color: '#856404' }}>User Management Upgrade</h3>
        <p style={{ color: '#856404', margin: '8px 0' }}>
          This system now uses proper Cognito integration for user management.
        </p>
        <p style={{ color: '#856404', margin: '8px 0' }}>
          <strong>What's New:</strong>
        </p>
        <ul style={{ color: '#856404', marginLeft: '20px' }}>
          <li>AWS Cognito User Pool integration</li>
          <li>Dual creation (Cognito user + Employee record)</li>
          <li>Proper authentication and authorization</li>
          <li>Temporary passwords with forced reset</li>
          <li>Role-based access control</li>
        </ul>
      </div>
      
      <CognitoUserManagement user={user} session={session} />
    </div>
  );
};

export default UserManagement;